module.exports = __webpack_public_path__ + "img/Corner-New.805e58b8.png";